// src/components/UI/CatalogueRefreshModal.js
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './CatalogueRefreshModal.module.css';

// Blocking popup that asks the seller to refresh their catalogue.
// Intentionally non-dismissable: no close button, no skip, no backdrop click.
// If `onProceed` rejects, the error is shown inline and the button becomes a retry.
const CatalogueRefreshModal = ({ isOpen, onProceed }) => {
    const [error, setError] = useState(null);

    if (!isOpen) return null;

    const handleProceed = async (e) => {
        setError(null);
        try {
            await onProceed?.(e);
        } catch (err) {
            console.error('Catalogue refresh failed:', err);
            setError("We couldn't refresh your catalogue just now. Please try again.");
        }
    };

    return ReactDOM.createPortal(
        <div className={styles.overlay}>
            <div
                className={styles.modal}
                role="dialog"
                aria-modal="true"
                aria-labelledby="catalogue-refresh-title"
                aria-describedby="catalogue-refresh-desc"
            >
                <div className={styles.iconWrap} aria-hidden="true">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2M20 19v-4h-4"
                            stroke="#2766AA"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <div className={styles.textBlock}>
                    <h2 id="catalogue-refresh-title" className={styles.title}>
                        Your catalogue needs a quick refresh
                    </h2>
                    <p id="catalogue-refresh-desc" className={styles.subtitle}>
                        Click Proceed to refresh your catalogue. We'll pull your latest Amazon listings
                        so everything here matches your store. It only takes a moment.
                    </p>
                </div>

                <button type="button" className={styles.proceedBtn} onClick={handleProceed}>
                    {error ? 'Try again' : 'Proceed'}
                </button>

                {error && <p className={styles.error} role="alert">{error}</p>}
            </div>
        </div>,
        document.body
    );
};

export default CatalogueRefreshModal;
